<template>
  <v-text-field
    :name="name"
    :value="value"
    :mask="cpfcnpj_mask"
    :label="cpfcnpj_label"
    @input="sendValue"
    @blur="$emit('blur')"
    :disabled="disabled"
    :error-messages="errors.collect(name)"
    :data-vv-as="data_vv_as ? data_vv_as : cpfcnpj_label"
    data-vv-validate-on="blur"
    v-validate="cpfcnpj_validate"
  ></v-text-field>
</template>

<script>
export default {
  name: "PCpfCnpj",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    v_validate: {
      type: String,
      default: "",
    },
    data_vv_as: {
      type: String,
    },
  },
  data() {
    return {
      cpfcnpj_validate: "",
      complemento: "",
    };
  },
  methods: {
    sendValue(value) {
      this.cpfcnpj_validate =
        value && value.length > 11 ? "validCnpj|" + this.v_validate : "validCpf|" + this.v_validate;
      this.$emit("input", value);
    },
  },
  computed: {
    cpfcnpj_label() {
      this.complemento = this.label ? ` ${this.label}` : "";
      return this.value && this.value.length > 11
        ? "CNPJ" + this.complemento
        : "CPF" + this.complemento;
    },
    cpfcnpj_mask() {
      return this.value && this.value.length > 11 ? "##.###.###/####-##" : "###.###.###-###";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/PCpfCnpj.vue